import {
    collection,
    addDoc,
    query,
    orderBy,
    limit,
    onSnapshot,
    serverTimestamp,
    type Unsubscribe,
    deleteDoc,
    doc
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import type { ChatMessage, CreateChatMessageData } from '@/types';
import { convertTimestamps, TIMESTAMP_FIELDS } from '@/utils/firestore';

export class ChatService {

    static async sendMessage(playlistId: string, messageData: CreateChatMessageData): Promise<void> {
        const chatRef = collection(db, 'playlists', playlistId, 'chat');

        await addDoc(chatRef, {
            ...messageData,
            createdAt: serverTimestamp()
        });
    }

    static async deleteMessage(playlistId: string, messageId: string): Promise<void> {
        const msgRef = doc(db, 'playlists', playlistId, 'chat', messageId);
        await deleteDoc(msgRef);
    }

    static subscribeToChat(playlistId: string, callback: (messages: ChatMessage[]) => void, messageLimit = 100): Unsubscribe {
        const chatRef = collection(db, 'playlists', playlistId, 'chat');
        const q = query(chatRef, orderBy('createdAt', 'asc'), limit(messageLimit));

        return onSnapshot(q, (snapshot) => {
            const messages = snapshot.docs.map(doc => ({
                id: doc.id,
                ...convertTimestamps<Omit<ChatMessage, 'id'>>(doc.data() as any, TIMESTAMP_FIELDS.chatMessage as any)
            }));

            // Note: Data coming from serverTimestamp might be null momentarily (latency compensation),
            // but our convertTimestamps handles simple Date conversion.
            // Ideally we filter out messages where createdAt is null if local write hasn't resolved, 
            // but for chat it's usually fine to show them at the bottom.

            callback(messages as ChatMessage[]);
        });
    }
}
